"use client";

import React, { Suspense } from "react";
import dynamic from 'next/dynamic';
import {
    Gear,
    ChartBar,
    Cloud,
    Cpu,
    Lightbulb,
    ShieldCheck,
    Envelope,
    Phone,
    ChatText,
    Globe,
    Users,
    ClipboardText
} from "@/app/components/Icons/Phosphoricons";
import HeroSectionBTS from "@/app/businesstechsolutions/components/HeroSectionBTS";

const ContentBTS = dynamic(() => import("@/app/businesstechsolutions/components/ContentBTS"), {
    suspense: true
});
const AllInOnePlatform = dynamic(() => import("@/app/components/AllInOnePlatform"), {
    suspense: true
});
const AWSConnectFeature = dynamic(() => import("@/app/businesstechsolutions/components/AWSConnectFeatureBTS"), {
    suspense: true
});

const HighlightsBTS = dynamic(() => import("@/app/businesstechsolutions/components/HighlightsBTS"), {
    suspense: true
});
const MarketingNotificationsBTS = dynamic(() => import("@/app/businesstechsolutions/components/MarketingNotificationsBTS"), {
    suspense: true
});
const AutomationFeaturePricing = dynamic(() => import("@/app/pricing/components/AutomationFeaturePricing"), {
    suspense: true
});

const features = [
    // 🔹 Automation
    {
        name: "Workflow Automation",
        icon: Gear,
        description: "Eliminate repetitive tasks with intelligent automation that improves efficiency and reduces operational costs.",
    },
    {
        name: "Business Process Optimization",
        icon: ChartBar,
        description: "Streamline and enhance business workflows through automation, enabling teams to focus on strategic initiatives.",
    },
    {
        name: "Scalable Automation Architecture",
        icon: Cloud,
        description: "Built to scale with your business, ensuring seamless automation expansion without system slowdowns.",
    },

    // 🔹 AI Agents
    {
        name: "AI-Powered Assistants",
        icon: Cpu,
        description: "Automate customer interactions, support, and business decision-making with AI-driven virtual agents.",
    },
    {
        name: "AI Insights & Predictive Analytics",
        icon: Lightbulb,
        description: "Leverage AI to analyze data trends, predict customer behavior, and drive data-informed decisions.",
    },
    {
        name: "Self-Learning AI Agents",
        icon: ShieldCheck,
        description: "Continuously improve customer interactions with adaptive AI agents that evolve based on real-world interactions.",
    },

    // 🔹 Email Solutions (AWS-Based)
    {
        name: "Enterprise-Grade Email Hosting",
        icon: Envelope,
        description: "Secure, scalable, and high-performance cloud-based email infrastructure for seamless business communication.",
    },
    {
        name: "Transactional & Marketing Email",
        icon: Cloud,
        description: "Reliable email delivery for transactional notifications, newsletters, and automated campaigns.",
    },
    {
        name: "Advanced Email Security & Compliance",
        icon: ShieldCheck,
        description: "Protects against phishing, spam, and email-based threats while ensuring compliance with data protection laws.",
    },

    // 🔹 Phone Solutions (AWS-Based)
    {
        name: "Cloud-Based Business Telephony",
        icon: Phone,
        description: "Flexible, scalable, and cost-effective business phone solutions powered by secure cloud infrastructure.",
    },
    {
        name: "VoIP & Multi-Device Support",
        icon: ChatText,
        description: "Connect teams and customers across devices with high-quality voice communication and VoIP support.",
    },
    {
        name: "Global Call Management & Routing",
        icon: Globe,
        description: "Intelligent call routing ensures the right person is reached, enhancing efficiency and customer satisfaction.",
    },

    // 🔹 Chat Solutions (AWS-Based)
    {
        name: "Real-Time Business Messaging",
        icon: ChatText,
        description: "Enhance customer engagement and team collaboration with secure, real-time chat solutions.",
    },
    {
        name: "AI Chatbots for Customer Support",
        icon: Cpu,
        description: "Automate customer queries with AI-powered chat solutions, reducing response times and improving satisfaction.",
    },
    {
        name: "Multi-Channel Communication",
        icon: Users,
        description: "Integrate chat with phone, email, and social platforms for a seamless customer experience.",
    },

    // 🔹 Consulting
    {
        name: "Business Technology Strategy",
        icon: Lightbulb,
        description: "Expert consulting to help businesses optimize, implement, and scale technology solutions for long-term growth.",
    },
    {
        name: "IT Infrastructure & Cloud Consulting",
        icon: Cloud,
        description: "Guidance on migrating to cloud platforms, optimizing infrastructure, and maximizing performance.",
    },
    {
        name: "Regulatory Compliance & Security Audits",
        icon: ClipboardText,
        description: "Ensure your technology solutions meet industry standards for security, data protection, and compliance.",
    },
];

export default function Page() {
    return (
        <main>
           <HeroSectionBTS />

            <Suspense fallback={<div>Loading...</div>}>
                <HighlightsBTS />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
                <AWSConnectFeature />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
                <MarketingNotificationsBTS />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
                <ContentBTS />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
                <AllInOnePlatform
                    title="Custom Software Solutions"
                    subtitle="Transform your business with custom software solutions that scale. Our full-stack expertise delivers everything from user interfaces to complex backend systems, all tailored to your specific needs."
                    features={features}
                />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
                <AutomationFeaturePricing />
            </Suspense>
        </main>
    );
}